/**
 * Shared auth helpers for the passwordless (OTP email) login flow.
 */

/**
 * Validates an ordinary post-auth redirect target.
 * Only accepts internal same-origin paths; rejects absolute/protocol-relative
 * URLs, malformed values, and every authentication workflow route.
 */
export function validateOrdinaryPostAuthNext(next: unknown): string {
  if (typeof next !== 'string' || next.length === 0) return '/';
  if (!next.startsWith('/') || next.startsWith('//')) return '/';
  if (next === '/auth' || next.startsWith('/auth/')) return '/';

  const lower = next.toLowerCase();
  const blocked = [
    '/login',
    '/accounts',
    '/register',
    '/signup',
    '/forgot-password',
    '/reset-password',
  ];
  if (blocked.includes(lower)) return '/';

  return next;
}

/**
 * Builds the absolute URL for the auth callback, taking the app base path
 * into account (e.g. Readdy preview deployments run under a sub-path).
 */
export function getAbsoluteCallbackUrl(): string {
  const base = (__BASE_PATH__ || '/').replace(/\/+$/, '');
  const root =
    base && base !== '/' ? `${window.location.origin}${base}` : window.location.origin;
  return `${root}/auth/callback`;
}